export default class SignInService {
  static getInstance() {
    if (!SignInService.instance) {
      SignInService.instance = new SignInService();
    }
    return SignInService.instance;
  }

  async refreshToken() {
    if (!SignInService._signingOut) {
      alert('Session expired. Please login again.');
    }
    return this.signOut();
  }

  async signOut() {
    if (SignInService._signingOut) return;
    SignInService._signingOut = true;
    localStorage.setItem('userType', '');
    localStorage.setItem('token', '');
    localStorage.setItem('userId', '');
    console.log('User signed out.');
    window.location.reload();
  }
}
